if ( !customElements.get('pricing-info') ) {
    class PricingInfo extends HTMLElement {
        constructor() {
            super();

            this.pricingData = null;

            this.currentPriceEl = null;
            this.comparePriceEl = null;
            this.compareStrikeEl = null;
            this.inStoreWrapper = null;
            this.inStorePriceEl = null;
        }

        connectedCallback() {
            this.initElements();
            this.loadPricingData();
        }

        initElements() {
            this.currentPriceEl = this.querySelector('[data-price-current]');
            this.comparePriceEl = this.querySelector('[data-price-compare]');
            this.compareStrikeEl = this.comparePriceEl?.querySelector('s');
            this.inStoreWrapper = this.querySelector('[data-price-instore]')?.closest('.product-pricing');
            this.inStorePriceEl = this.querySelector('[data-price-instore]');
        }

        loadPricingData() {
            const script = this.querySelector('#product-pricing-data');

            if ( script == null ) { 
                console.log( 'no script' )
                return; 
            }

            try {
                this.pricingData = JSON.parse( script.innerHTML );
            } catch ( e ) {
                console.error( 'Invalid pricing JSON', e );
            }
        }

        updateForVariant( variantId ) {
            if ( !this.pricingData ) { 
                return;
            }

            const variant = this.pricingData.variants.find(
                v => String( v.id ) === String( variantId )
            );

            if ( !variant ) { 
                return; 
            }

            this.updateOnlinePrice( variant );
            this.updateInStorePrice( variant );
        }

        updateOnlinePrice( variant ) {
            if ( !this.currentPriceEl ) { 
                return; 
            }

            this.currentPriceEl.textContent = variant.price_formatted;

            if ( variant.compare_at_price_raw && variant.compare_at_price_raw > variant.price_raw ) {
                if ( this.compareStrikeEl ) {
                    this.compareStrikeEl.textContent = variant.compare_at_price_formatted;
                }
                this.comparePriceEl.hidden = false;
            } else {
                this.comparePriceEl.hidden = true;
            }
        }

        updateInStorePrice( variant ) {
            if ( !this.inStoreWrapper || !this.inStorePriceEl ) { 
                return; 
            }

            if ( variant.in_store_price_raw ) {
                this.inStorePriceEl.textContent = variant.in_store_price_formatted;
                this.inStoreWrapper.hidden = false;
            } else {
                this.inStoreWrapper.hidden = true;
            }
        }
    }

    customElements.define('pricing-info', PricingInfo);
}